import {
  getOwnConsumptions, exportOwnConsumptions, importOwnConsumptions,
} from '../../../Api/services/backoffice';

export const key = 'ownConsumption';

const entityName = {
  singular: 'Consumo Próprio',
  plural: 'Consumo Próprio',
};

const queries = {
  list: { key, fn: getOwnConsumptions },
  detail: { key },
};

const fields = {
  table: [
    { key: 'code', label: 'Código' },
    { key: 'updateAt', label: 'Atualizado em', mask: 'date' },
    { key: 'status', label: 'Status' },
  ],
};

export const listConfig = {
  title: entityName.plural,
  tableFields: fields.table,
  searchFields: fields.search,
  queryConfig: queries.list,
  hideCreateButton: true,
  hideUpdateButton: true,
  showBatchButton: true,
};

export const batchConfig = {
  entityName: entityName.plural,
  exportFn: exportOwnConsumptions,
  importFn: importOwnConsumptions,
};
